import { Link } from "@tanstack/react-router";
import { useTranslation } from "@/i18n/use-t";
import { LanguageSwitcher } from "./LanguageSwitcher";

export function AppHeader() {
  const { t } = useTranslation("common");
  return (
    <header
      data-print-hide
      className="sticky top-0 z-10 border-b border-border bg-background/80 backdrop-blur"
    >
      <div className="mx-auto flex w-full max-w-3xl items-center justify-between gap-4 px-4 py-3 sm:px-6">
        <Link
          to="/"
          className="flex items-center gap-2 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 focus-visible:ring-offset-background rounded-md"
        >
          <span
            aria-hidden
            className="inline-flex h-7 w-7 items-center justify-center rounded-md bg-primary text-primary-foreground font-bold text-sm"
          >
            B
          </span>
          <span className="flex flex-col leading-tight">
            <span className="text-sm font-semibold tracking-tight">
              {t("app.name")}
            </span>
            <span className="text-[10px] uppercase tracking-widest text-muted-foreground">
              {t("app.tagline")}
            </span>
          </span>
        </Link>
        <LanguageSwitcher />
      </div>
    </header>
  );
}
